import { AnalyticsChartPeriods } from './analyticsChartPeriods';
import * as moment from 'moment'

export function getAnalyticsReportDates(start: number | Date | moment.Moment, end: number, period: AnalyticsChartPeriods) {
    let startTs = +moment(start).startOf('day'), endTs = +moment(end).endOf('day');
    let timeUnit: moment.unitOfTime.StartOf = 'day';

    if (!period) {
        throw new Error('No period provided for date calculation');
    }

    if (period === AnalyticsChartPeriods.Daily && !end) {
        endTs = +moment(start).endOf('day')
    }

    // if (period === AnalyticsChartPeriods.Daily) {
    //     timeUnit = 'day';
    // } else if (period === AnalyticsChartPeriods.Weekly) {
    //     timeUnit = 'week';
    // } else if (period === AnalyticsChartPeriods.Monthly) {
    //     timeUnit = 'month';
    // }

    // startTs = +moment(start).startOf('day');
    // if (!endTs) {
    //     endTs = +moment(end ? end : start).endOf(timeUnit);
    // }

    return {
        startTs, endTs
    };
}